;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="48ea8c31-c87d-4fbe-96dd-180656727ee0",e._sentryDebugIdIdentifier="sentry-dbid-48ea8c31-c87d-4fbe-96dd-180656727ee0")}catch(e){}}();import '../_virtual/_sentry-release-injection-file.js';

const BITIBA_FONTS = `
  @font-face {
    font-family: Patrick Hand;
    font-style: normal;
    font-weight: 400;
    src: local(),
      url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/patrick-hand-latin-regular.woff2)
        format(woff2), url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/patrick-hand-latin-regular.woff
        format(woff);
  }
  @font-face {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: 700;
    src: local(),
      url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/roboto-slab-latin-700.woff2)
        format(woff2), url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/roboto-slab-latin-700.woff)
        format(woff);
  }
`;
const ZOOPLUS_FONTS = `
    @font-face {
      font-family: Nunito;
      font-style: normal;
      font-weight: 400;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-regular.woff2) format(woff2);
    }

    @font-face {
      font-family: Nunito;
      font-style: italic;
      font-weight: 400;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-italic.woff2) format(woff2);
    }

    @font-face {
      font-family: Nunito;
      font-style: normal;
      font-weight: 500;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-500.woff2) format(woff2);
    }

    @font-face {
      font-family: Nunito;
      font-style: normal;
      font-weight: 700;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-700.woff2) format(woff2);
    }
  `;
const THEME_FONTS = {
    zooplus: ZOOPLUS_FONTS,
    bitiba: BITIBA_FONTS,
};
const getWebFonts = (isBitiba) => {
    return isBitiba ? THEME_FONTS.bitiba : THEME_FONTS.zooplus;
};

export { getWebFonts };
//# sourceMappingURL=fontUtils.js.map
